import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ContentSearchService {

  constructor(private _http: HttpClient) { }


  startContentTraining(agentId, params) {
    return this._http.post(environment.content_training_api + 'content_search/'+ agentId + '/train', params)
  }

  checkStatus(agentId, task_id) {
    return this._http.get(environment.content_training_api + 'content_search/'+ agentId + '/status/'+ task_id)
  }
  
  getAnswersList(agentId, params) {
    return this._http.post( environment.content_search_api + agentId + '/predict_docscontent', params )
  }

  getGeneratedAnswer(agentId, params) {
    return this._http.post( environment.content_search_api + agentId + '/cira-doc-generator', params )
  }

  predictInfo(params) {
    return this._http.post( environment.generateque_service + '/identify', params)
  }

  deleteDocFromWeviateDB(agentId, params) {
    return this._http.post( environment.content_training_api + 'content_search/' + agentId + '/deletedocuments', params)
  }

}
